export default __webpack_public_path__ + "static/media/u2.502e30fa.png";